import styled, { css } from 'styled-components';
import { accent0, focus, gray5 } from '../../globals/colors';
import { bubbleMixin, flexCenterMixin } from '../../styles/mixins';
import alpha from '../../utility/alpha';
import { SidePanelFrame, SidePanelFrameLeftContent, SidePanelFrameMidSlot } from '../SidePanelFrame';
import { breakpoints,  responsivePropertyMixin } from '../../styles/mixins';

export const checkmarkCss = css`
    color: ${accent0};
    font-size: 1.5em;
`;

export const SidePanelFrameStyled = styled(SidePanelFrame)`
    ${SidePanelFrameLeftContent} > ${SidePanelFrameMidSlot} {
        visibility: hidden;
    }

    input:not(:checked) + label {
        border-color: transparent;
    }

    input:checked + label {
        border-color: white;
    }

    input:focus + label {
        border-color: ${focus};
        background: ${alpha(gray5, .1)};
    }

    input:checked ~ div {
        ${SidePanelFrameMidSlot} {
            visibility: visible;
        }
    }
`;

export const CompactFrameStyle = styled(SidePanelFrame)`
    ${SidePanelFrameLeftContent} > ${SidePanelFrameMidSlot} {
        visibility: hidden;
    }

    label {
        ${responsivePropertyMixin(breakpoints, [
        ['font-size', '1.5rem !important', '1.5rem !important', '2rem !important']
    ])}
    }

    input:not(:checked) + label {
        border-color: transparent;
    }

    input:checked + label {
        border-color: ${accent0};
    }

    input:focus + label {
        background: ${alpha(gray5, .1)};
    }

    input:checked ~ div {
        ${SidePanelFrameMidSlot} {
            visibility: visible;
        }
    }
`;

export const CheckmarkBubble = styled.div`
    ${bubbleMixin}
    ${flexCenterMixin}
    border-width: 2px;
    border-color: ${accent0};
    cursor: pointer;
`;
